
import Button from './common/Button.vue';
import Points from './common/Points.vue';
import SectionHeader from './common/SectionHeader.vue';
import Swiper from './common/Swiper.vue';
import Tags from './common/Tags.vue';
import { reachGoal } from './utils/metrika.js';

const SWIPER_STYLES = `
  :host .swiper-wrapper {
    overflow: visible !important;
    align-items: stretch;
  }
  :host .swiper {
    overflow: visible !important;
    padding: 0 var(--side-indent);
    width: calc(100% - var(--side-indent) * 2);
  }
  @media (min-width: 1025px) {
    :host .swiper-wrapper {
      height: auto !important;
      transform: unset !important;
      flex-direction: column !important;
      row-gap: 72px;
    }
    :host .swiper {
      padding: 0;
      width: 100%;
      overflow: visible !important;
    }
  }
`;

export default {
  name: 'MeatPageSuppliers',
  components: { Swiper, SectionHeader, Button, Tags, Points },
  props: {
    data: {
      type: Object,
      required: true
    },
    common: {
        type: Object,
        default: () => ({})
    }
  },
  data() {
    return {
      ticking: false,
    };
  },
  computed: {
    swiperOptions() {
      return {
        slidesPerView: 1,
        spaceBetween: 16,
        /* autoplay: {
            enabled: true,
            speed: 6000,
        }, */
        breakpoints: { 1025: { enabled: false } },
        navigation: {
          enabled: true
        },
        on: {
          navigationNext: () => {
            this.reachGoal('click_suppliers_mobile_carousel_next')
          },
          navigationPrev: () => {
            this.reachGoal('click_suppliers_mobile_carousel_prev')
          },
        },
        injectStyles: [SWIPER_STYLES],
      };
    }
  },
  mounted() {
    this.resizeHandler = () => {
      if (window.innerWidth >= 1025) {
        this.enableStacking();
      } else {
        this.disableStacking();
      }
    };

    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    reachGoal,
    getCurrentHalalIcon(index) {
      return this.data.items[index].emblem.src ? this.data.items[index].emblem : this.common[['halalKazakhstanImage', 'halalBelarusImage', 'halalIndiaImage'][index % 3]]
    },
    handleButtonMoreClick(supplier) {
        this.reachGoal('click_supplier_detail', { href: supplier.buttonMore.href })
        this.$router.push(supplier.buttonMore.href);
    },
    enableStacking() {
      if (this.stackingEnabled) return;
      this.stackingEnabled = true;

      this.scrollHandler = () => {
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.updateStacking();
            this.ticking = false;
          });
          this.ticking = true;
        }
      };

      window.addEventListener('scroll', this.scrollHandler);
      this.updateStacking();
    },
    disableStacking() {
      if (!this.stackingEnabled) return;
      this.stackingEnabled = false;

      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;

      const wrapper = this.$refs.cardsWrapper;
      if (!wrapper) return;
      wrapper.querySelectorAll('.supplier-card').forEach(card => {
        card.style.transform = '';
        card.style.filter = '';
        card.style.opacity = '';
      });
    },
    updateStacking() {
      const wrapper = this.$refs.cardsWrapper;
      if (!wrapper) return;

      const cards = wrapper.querySelectorAll('.supplier-card');
      cards.forEach((card, i) => {
        const nextCard = cards[i + 1];
        if (!nextCard) return;

        const rect = card.getBoundingClientRect();
        const nextRect = nextCard.getBoundingClientRect();
        const distanceBetween = nextRect.top - rect.top;
        const cardHeight = card.offsetHeight;

        if (distanceBetween < cardHeight) {
          const progress = 1 - distanceBetween / cardHeight;
          card.style.transform = `scale(${1 - progress * 0.1}) translateY(${-(progress * cardHeight * 0.25)}px)`;
          card.style.filter = `brightness(${1 - progress * 0.4})`;
          card.style.opacity = 1 - progress * 0.3;
        } else {
          card.style.transform = 'scale(1) translateY(0px)';
          card.style.filter = 'brightness(1)';
          card.style.opacity = 1;
        }
      });
    }
  }
}
